// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toasted {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.text-greyout input {\n  color: grey !important;\n}\n\n", "",{"version":3,"sources":["webpack://assets/main.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".toasted {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.text-greyout input {\n  color: grey !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
